import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=5543a626"
import script from "./DeliveryDetails.vue?vue&type=script&lang=ts"
export * from "./DeliveryDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports